import React from "react";
import { Tooltip } from 'antd';
import { IItemData } from "./common.typing";

export interface IOrgBreadProps {
  orgBread: IItemData[];
  getOrgList?: (obj?: IItemData) => void;
}

const OrgBread: React.FC<IOrgBreadProps> = ({ orgBread, getOrgList }) => {
  const onClickBread = (
    index: number,
    id: number | string,
    name: string
  ) => {
    if (index === orgBread.length - 1) return;
    getOrgList && getOrgList({ id, name });
  };

  return (
    <div className="orgBread">
      {orgBread && !!orgBread.length && orgBread.map((item, index) => (
        // <div
        //   key={item.id}
        //   className="item"
        //   onClick={() => onClickBread(index, item.id, item.name)}
        // >
        //   <span>{item.name}</span>
        //   <span className="right">/</span>
        // </div>
          <div key={item.id} className="item" onClick={() => onClickBread(index, item.id, item.name)}>
              <Tooltip placement="top" title={item.name} overlayStyle={{ fontSize: '12px' }}>
                  <span className="name">{item.name}</span>
              </Tooltip>
              <i className="right">&nbsp;/&nbsp;</i>
          </div>
      ))}
    </div>
  );
};

export default OrgBread;
